var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onSyncGifts
    }
  }, [_vm.isSyncLoading ? [_vm._v("同步中...")] : [_vm._v("同步电报礼品")]], 2), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("添加新礼品")]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)]), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 0 && 'active',
    on: {
      "click": function ($event) {
        _vm.selectTab = 0;
        _vm.condition.page = 1;
        _vm.onRefresh();
      }
    }
  }, [_vm._v("启用的")]), _c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 1 && 'active',
    on: {
      "click": function ($event) {
        _vm.selectTab = 1;
        _vm.condition.page = 1;
        _vm.onRefresh();
      }
    }
  }, [_vm._v("禁用的")])]), _c('div', {
    staticClass: "task-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.gift_name) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.gift_id) + " ")]), _c('div', {
      staticClass: "s icon"
    }, [item.gift_thumb ? _c('img', {
      attrs: {
        "src": item.gift_thumb,
        "height": "30px"
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.gift_stars) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.gift_tons) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.recycling_stars) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.gift_type == 0 ? '电报原生' : "" + item.gift_type == 1 ? '电报NFT' : '其他') + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.required_shards) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.shard_winning_weight) + " ")]), _c('div', {
      staticClass: "s url"
    }, [_vm._v(" " + _vm._s(item.shard_winning_limits) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.is_default == 0 ? '否' : "是") + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.remarks) + " ")]), _c('div', {
      staticClass: "s status",
      class: `status_${item.status}`
    }, [_vm._v(" " + _vm._s(item.status == 0 ? '禁用' : '启用') + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.created_at)) + " ")]), _c('div', {
      staticClass: "s opt"
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onModify(item);
        }
      }
    }, [_vm._v("编辑")])])]);
  })], 2), _c('div', {
    staticClass: "data-bd"
  }, [_c('my-pagination', {
    staticClass: "pagination",
    attrs: {
      "total": _vm.total,
      "page-size": _vm.condition.limit,
      "page": _vm.condition.page,
      "on-page-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1), _c('pop-lucky-gift', {
    attrs: {
      "show": _vm.popGitfShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popGitfShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s"
  }, [_vm._v(" ID ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 礼品名称 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 礼品ID(原生) ")]), _c('div', {
    staticClass: "s icon"
  }, [_vm._v(" ICON ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 星星价值 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" Ton价值 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 回收星星 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 礼品类型 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 合成礼物所需的碎片数 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 碎片中奖概率权重 ")]), _c('div', {
    staticClass: "s url"
  }, [_vm._v(" 碎片付费等级中奖百分比上限 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 是否默认 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 备注 ")]), _c('div', {
    staticClass: "s status"
  }, [_vm._v(" 状态 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 添加时间 ")]), _c('div', {
    staticClass: "s opt"
  })]);
}];
export { render, staticRenderFns };